import React from 'react';
import { Link } from 'react-router-dom';
import site from '../content/siteContent';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-wood !important">
      {/* Main Footer */}
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Company Info */}
          <div className="md:col-span-4 space-y-4">
            <div>
              <h3 className="font-semibold text-xl text-sand mb-2">{site.name}</h3>
              <p className="text-sand/90 text-sm leading-relaxed">
                Crafting timeless interiors with precision and passion. We transform spaces into
                functional works of art that reflect your style and needs.
              </p>
            </div>
            <div className="space-y-2">
              <a
                href="tel:+919842084477"
                className="text-sand hover:text-white flex items-center gap-2 text-sm group"
              >
                <svg
                  className="w-4 h-4 group-hover:scale-110 transition"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                +91 98420 84477
              </a>
              <a
                href="tel:+919842884477"
                className="text-sand hover:text-white flex items-center gap-2 text-sm group"
              >
                <svg
                  className="w-4 h-4 invisible"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                +91 98428 84477
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h4 className="font-medium text-sand mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                ['Home', '/'],
                ['About', '/about'],
                ['Services', '/services'],
                ['Portfolio', '/portfolio'],
                ['Contact', '/contact'],
              ].map(([title, url]) => (
                <li key={url}>
                  <Link
                    to={url}
                    className="text-sand/80 hover:text-white text-sm transition duration-150 ease-in-out"
                  >
                    {title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="font-medium text-sand mb-4">Our Services</h4>
            <ul className="space-y-2">
              {site.services.slice(0, 5).map((service, idx) => (
                <li key={idx}>
                  <Link
                    to="/services"
                    className="text-sand/80 hover:text-white text-sm transition duration-150 ease-in-out"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Address */}
          <div className="md:col-span-3">
            <h4 className="font-medium text-sand mb-4">Visit Us</h4>
            <address className="not-italic">
              <p className="text-sand/90 text-sm leading-relaxed">
                187 H, Kandigaiperi Rd,
                <br />
                Gnanadas Nagar, Valliyur,
                <br />
                Vadakkuvalliyur,
                <br />
                Tamil Nadu 627117
              </p>
            </address>
            <div className="mt-4">
              <h4 className="font-medium text-sand mb-2">Business Hours</h4>
              <p className="text-sand/90 text-sm">{site.hours}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-sand/10">
        <div className="container py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-sand/80">
            <div>
              © {year} {site.name}. All rights reserved.
            </div>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="hover:text-white transition">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-white transition">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
